const BACK_OFFICE_MASTER_DATA_URL = "/master-data/general-ledger";

export default [
  {
    level: 3,
    key: "title.chartOfAccount",
    keywords: "chart,account",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/coa`,
  },
  {
    level: 3,
    key: "title.chartOfAccountCategoryMenu",
    keywords: "chart,account,category",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/coa-category`,
    icon: "mdi-database",
  },
  {
    level: 3,
    key: "title.generalLedgerBudget",
    keywords: "general,ledger,budget",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/budget`,
  },
  {
    level: 3,
    key: "title.cashFlowBudget",
    keywords: "cash,flow,budget",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/cash-flow-budget`,
  },
];
